export default __webpack_public_path__ + "static/media/allseis-1C.40905c56.jpg";